import { UPDATE_GALLERY, APP_MOUNT } from '../actions/actionTypes';

const initialState = {
  assets: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_GALLERY:
      return {
        assets: action.assets.map((item, index) => ({
          ...item,
          primaryLink: encodeURI(item.primaryLink),
          thumbnail: encodeURI(item.thumbnail),
          key: index,
        })),
      };
    case APP_MOUNT: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};
